const reveal = document.querySelector("[data-reveal-drawer]");

if (reveal) {
  reveal.addEventListener("click", (e) => {
    e.preventDefault();
    const id = e.currentTarget.dataset.revealDrawer;
    const drawer = document.querySelector(id);
    drawer.toggle();
  });
}


if (!customElements.get("reveal-drawer")) {
  class RevealDrawer extends HTMLElement {
    constructor() {
      super();
      this.closeBtns = this.querySelectorAll(".close-button,.drawer-backdrop");
      this.drawer = this.querySelector(".drawer-inner");
      this.inkRadios = document.querySelector('ink-radios');

      this.closeBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
          this.hide();
        });
      });
    }
    toggle() {
      this.classList.contains("drawer-outer-reveal")
        ? this.hide()
        : this.show();
    }
    hide() {
      this.classList.add("drawer-outer-hidden");
      this.classList.remove("drawer-outer-reveal", "animate");
      document.body.classList.remove('drawer-active');
    }
    show() {
      if (this.inkRadios) {
        this.inkColor = this.inkRadios.querySelector('input:checked');
        if (!this.inkColor) {
          this.inkRadios.querySelector('input + label').focus();
          this.inkRadios.querySelector('.product-form__error-message-wrapper').removeAttribute('hidden');
          this.inkRadios.querySelector('.product-form__error-message').textContent = 'Please select an ink color';
          return;
        } else {
          this.inkRadios.clearError()
        }
      }
      this.classList.remove("drawer-outer-hidden");
      this.classList.add("drawer-outer-reveal", "animate");
      document.body.classList.add('drawer-active');
    }
  }
  customElements.define("reveal-drawer", RevealDrawer);
}
